<template>
  <ModalDialog
    ref="dialog"
    title="Proxy Login to Account"
    icon="fa-sign-in-alt"
    :submitting="submitting"
    submitTitle="Access"
    @closed="onClosed"
    @submitted="onSubmitted">

    <NotificationBar type="warning">
      <NotificationBarTitle>Proxy Login</NotificationBarTitle>
      This action will logout the current session and login via proxy to access the selected account&apos;s user.<br />
      To exit, logout from the proxy session.<br />
      <strong>Note: </strong> After exiting a proxy session, ensure to do a full refresh in the browser (Ctrl-Shift-R) to clear any session details<br />
      <strong>Note: </strong> MFA must be setup on the developer user
    </NotificationBar>

    <FormGroup v-bind:form="form" :labelColumnSize="2">
      <FormRow label="User Password"><FormInputText type="password" v-model="password" field="password" placeholder="Password" note="Enter your password to confirm access" /></FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'DeveloperProxyLogin',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    accountId: Number,
    user: Object
  },
  data() {
    return {
      form: {},
      password: '',
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      this.form = this.clearFormResponse()

      var proxyData = {
        accountId: this.accountId,
        password: this.password
      }
      if(this.user)
        proxyData.userId = this.user.id

      this.$apiService.developerService.developerProxyAccessAccount(proxyData)
      .then(response => {
        this.$authService.setAuthToken(response.data.token, true);
        this.$socketService.disconnect()

        // Completely refresh page
        window.location.href = '/'
      })
      .catch(err => {
        this.$data.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
  }
}
</script>